import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import diaryBot from "../../static/diarybot.png";
import randomBingo from "../../static/random-bingo.png";
import word2vecbook from "../../static/word2vec-book.png";
import streamlitbook from "../../static/streamlit-book.png";
import trybook2 from "../../static/trybook2.png";
import trybook3 from "../../static/trybook3.png";
import gasbook from "../../static/gas-book.png";
import solrbook from "../../static/solr-book.png";
import solrsupbook from "../../static/solr-sup-book.png";
import llmbook from "../../static/llm-book.png";
import solrOperator from "../../static/solr_operator.png"
import elasticOperator from "../../static/elastic_operator.png";
import reactPoorSearch from "../../static/react-poor-search.png";
import myKuchiguseCounter from "../../static/my-kuchiguse-counter.png";
import myChokoRecom from "../../static/mychoko-recom.png";
import cocCharaDice from "../../static/coc_charadice.png";
import graphragBook from "../../static/graphrag-book.png";
import apngMaker from "../../static/apng-maker.png";
import sameToneGenerator from "../../static/same-tone-generator.png";
import sreAutomationBook from "../../static/sre-automation-book.png";
import sreAutomationBook2 from "../../static/sre-automation-book2.png";
import solrMcpGo from "../../static/solr-mcp-go.png";
import vespaAdminUi from "../../static/vespa-admin-ui.png";
import { BiLinkExternal } from "react-icons/bi";
import { SlideInLeft, TypingText } from "./AnimationTrigger";
import IllustratorGallery from "./IllustratorGallery";

const apps = [
  {
    title: "Same Tone Generator",
    links: [
      {
        name: "APP LINK",
        link: "https://same-tone-generator.netlify.app/",
      },
    ],
    description:
      "指定した音階と同じ高さの音を生成するウェブアプリケーションです。",
    img: sameToneGenerator,
    badges: ["React"],
  },
  {
    title: "APNG Maker",
    links: [
      {
        name: "APP LINK",
        link: "https://apng-maker-nglmbwhf8h9qs95x5yywq8.streamlit.app/",
      },
    ],
    description:
      "複数のPNG画像からAPNG（Animated PNG）ファイルを作成するためのStreamlit製のウェブアプリケーションです。",
    img: apngMaker,
    badges: ["Python", "Streamlit"],
  },
  {
    title: "diarybot-Momo",
    links: [
      {
        name: "APP LINK",
        link: "https://github.com/Sashimimochi/diarybot-Momo",
      },
    ],
    description:
      "「会話形式で日記を書く」ことを目指したLINE用のチャットボットです。",
    img: diaryBot,
    badges: ["Python"],
  },
  {
    title: "ランダム縛りビンゴ",
    links: [
      {
        name: "APP LINK",
        link: "https://random-bingo.netlify.app/",
      },
      {
        name: "ランダム封印縛り",
        link: "https://dic.nicovideo.jp/a/%E3%83%A9%E3%83%B3%E3%83%80%E3%83%A0%E5%B0%81%E5%8D%B0%E7%B8%9B%E3%82%8A",
      },
    ],
    description:
      "ランダム封印縛り用に作成した縛り対象抽選ツールです。Excelファイルに必要事項を記入するだけで使えます。",
    img: randomBingo,
    badges: ["React"],
  },
  {
    title: "わたしのくちぐせカウンター",
    links: [
      {
        name: "APP LINK",
        link: "https://sashimimochi-my-kuchiguse-cnt-app-yy7mrj.streamlit.app/",
      },
    ],
    description:
      "テキストまたは音声ファイルからくちぐせをカウントするStreamlit製のウェブアプリです。",
    img: myKuchiguseCounter,
    badges: ["Python"],
  },
  {
    title: "教えて、手作りチョコレシピ！",
    links: [
      {
        name: "APP LINK",
        link: "https://mychoco-recom.netlify.app/",
      },
    ],
    description:
      "簡単な3つの質問に答えるだけで、あなたにおすすめの手作りチョコレシピが見つかります！",
    img: myChokoRecom,
    badges: ["React"],
  },
  {
    title: "CoC Character Making Dice",
    links: [
      {
        name: "APP LINK",
        link: "https://sashimimochi-cocdice-app-14ewsd.streamlit.app/",
      },
    ],
    description:
      "クトゥルフ神話TRPGのキャラ作成用のダイスアプリです。基礎能力はもちろん、ステータス振りまでワンクリックで提案してくれます。",
    img: cocCharaDice,
    badges: ["Python"],
  },
  {
    title: "solr-mcp-go",
    links: [
      {
        name: "GITHUB",
        link: "https://github.com/Sashimimochi/solr-mcp-go",
      },
      {
        name: "Docker Hub",
        link: "https://hub.docker.com/r/343mochi/solr-mcp-go",
      },
    ],
    description:
      "Apache SolrをAIエージェントから操作できるGo製のMCPサーバーです。DifyなどのAIプラットフォームと組み合わせることで、検索クエリの実行やスキーマ確認をAIから直接行えます。",
    img: solrMcpGo,
    badges: ["Go", "MCP", "Solr", "Docker"],
  },
  {
    title: "Vespa Admin UI",
    links: [
      {
        name: "GITHUB",
        link: "https://github.com/Sashimimochi/vespa-admin-ui",
      },
      {
        name: "Docker Hub",
        link: "https://hub.docker.com/r/343mochi/vespa-admin-ui",
      },
    ],
    description:
      "全文検索エンジンVespaの管理・デバッグ用ウェブUIです。SolrのSolr AdminやElasticsearchのKibanaに相当する管理画面がVespaには存在しないため、Vespaを使いこなしたいエンジニア向けに自作しました。YQLクエリ実行やドキュメント操作、ヘルスチェック、スキーマ確認、ログ閲覧などの機能を備えています。",
    img: vespaAdminUi,
    badges: ["TypeScript", "Next.js", "Vespa", "Docker"],
  },
];
const books = [
  {
    title: "GraphRAG完全ガイド RAGを越えた検索体験の実現に向けて",
    links: [
      {
        name: "SHOP",
        link: "https://nextpublishing.jp/book/19297.html",
      },
    ],
    description:
      "従来のRAGでは難しかった「文書全体の主題」や「抽象度の高い問い」に答えるための最新手法、GraphRAGを体系的に解説した実践書です。RAGの基礎から、Microsoft GraphRAG、公式ライブラリのハンズオン、LightRAGやNeo4j連携までを扱います。",
    img: "https://nextpublishing.jp/wp-content/uploads/2026/02/N02366.jpg",
    badges: ["Self-Authored", "GraphRAG", "RAG", "LLM", "Neo4j", "Python"],
  },
  {
    title: "ゼロから学ぶKubernetes × Elasticsearch運用",
    links: [
      {
        name: "SHOP",
        link: "https://nextpublishing.jp/book/19088.html",
      },
    ],
    description:
      "Kubernetes初心者でもElasticsearchクラスターを構築・運用できるよう、Dockerとの違い、スケーリング、自動復旧、機密情報管理や権限設定までを実践的に解説。ローカル構築からAzure環境へのデプロイまで学べます。",
    img: "https://nextpublishing.jp/wp-content/uploads/2025/12/N02308.jpg",
    badges: ["Self-Authored", "Kubernetes", "Elasticsearch", "Azure", "Docker"],
  },
  {
    title: "今日から始めるAI検索技術 Solrエンジニアのための最先端ガイド",
    links: [
      {
        name: "SHOP",
        link: "https://nextpublishing.jp/book/18504.html",
      },
    ],
    description:
      "キーワード検索からベクトル検索、生成AIと組み合わせたRAGまでを、Apache Solrを軸に実践的に解説。ニュアンス検索・類似画像検索・レコメンド機能や、Solr上での環境構築・チューニングまで学べる一冊です。",
    img: "https://nextpublishing.jp/wp-content/uploads/2025/02/N01895.jpg",
    badges: ["Self-Authored", "Solr", "VectorSearch", "RAG", "LLM", "Search"],
  },
  {
    title: "SRE自動化ハンドブック Vol.2 〜ログ検索からメトリクス、そして自律分析へ〜",
    links: [
      {
        name: "技術書典",
        link: "https://techbookfest.org/product/wYiKyttZ2bKykUqDCSNPXX",
      },
      {
        name: "BOOTH",
        link: "https://booth.pm/ja/items/8188250",
      },
    ],
    description:
      "ログとメトリクスをAIで統合し、自律的な原因分析を実現します。DifyとMCPを駆使し、自然言語でのシステム横断調査や自動可視化が可能に。情報の分断を解消し、障害対応を劇的に変える感動を体験できます。",
    img: sreAutomationBook2,
    badges: ["Self-Authored", "Prometheus", "Grafana", "Alertmanager", "Elasticsearch", "LLM", "MCP", "Dify", "SRE", "Slack"],
  },
  {
    title: "SRE自動化ハンドブック Vol.1 〜検索から対話へ－Elasticsearchでつくる運用支援システム〜",
    links: [
      {
        name: "技術書典",
        link: "https://techbookfest.org/product/66gJ3xvWVQKPufbR18GFZF",
      },
      {
        name: "BOOTH",
        link: "https://mochitto-cafe.booth.pm/items/7635678",
      },
    ],
    description:
      "つらい深夜のアラート対応を変えるべく、LLMとElasticsearchを組み合わせることで、対話的に調査・捜査可能な「運用自動化プラットフォーム」の構築方法を、実際に動くコードとともに解説します。",
    img: sreAutomationBook,
    badges: ["Self-Authored", "Elasticsearch", "LLM", "MCP", "Dify", "SRE"],
  },
  {
    title: "徹底攻略GraphRAG〜RAGを越えたその先の検索体験を開発せよ！〜",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/mS8k7jJxLPPuVn9xh3yWNn",
      },
      {
        name: "BOOTH",
        link: "https://booth.pm/ja/items/6992788?srsltid=AfmBOopeoocnMcKv0mo3dLqZqRKl_mnpC57HCCC8WlYYdWwUgApmKCsM",
      },
    ],
    description:
      "従来のRAGでは難しかった、出来事の関係性を考慮した回答や長大な文章の裏に隠れた趣旨といった抽象度の高い回答を実現できる手法として注目を集めているGraphRAGについて、難解な理論の解説はもちろん、サンプルコードたっぷりに実装方法の例も載せています。",
    img: graphragBook,
    badges: ["Self-Authored", "GraphRAG", "RAG", "LLM", "Python"],
  },
  {
    title: "ゼロから学ぶKubernetes × Solr運用",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/1qmwHdDEFeDXzGsNn0TB5h",
      },
      {
        name: "BOOTH",
        link: "https://mochitto-cafe.booth.pm/items/6282790",
      },
    ],
    description:
      "Kubernetes初心者がKubernetesの基礎から学び始めて全文検索エンジンSolrをKubernetes上で動かせるようになるまで学んだことをまとめた一冊です。最終的にはGKE上でSolrが動かせるようになります。",
    img: solrOperator,
    badges: ["Self-Authored", "Solr", "Kubernetes", "Go", "MySQL", "GCP"],
  },
  {
    title: "ゼロから学ぶKubernetes × Elasticsearch運用",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/wvVL92XBaqw9v2hBgi4Rh8",
      },
      {
        name: "BOOTH",
        link: "https://mochitto-cafe.booth.pm/items/6282813",
      },
    ],
    description:
      "Kubernetes初心者がKubernetesの基礎から学び始めて全文検索エンジンElasticsearchをKubernetes上で動かせるようになるまで学んだことをまとめた一冊です。最終的にはAKS上でElasticsearchが動かせるようになります。",
    img: elasticOperator,
    badges: ["Self-Authored", "Elasticsearch", "Kubernetes", "Python", "PostgreSQL", "Azure"],
  },
  {
    title: "貧弱環境でもここまでやれるLocal LLM",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/ehw1DzL9T4wn03CTd13VTA",
      },
      {
        name: "BOOTH",
        link: "https://mochitto-cafe.booth.pm/items/5851600",
      },
    ],
    description:
      "ローカルLLMをノートPC1台でどこまで動かせるか挑戦した本です。RAGやFunction Calling、果てはVision&Languageまでトライしています。限られた資源しかない環境でもLLMを使ってみたいという方に捧げる一冊です。",
    img: llmbook,
    badges: ["Self-Authored", "LLM", "Python", "MachineLearning"],
  },
  {
    title: "今日から始めるSolrベクトル検索",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/wSCmsmFye1bL6xDWRT6vVK",
      },
      {
        name: "BOOTH",
        link: "https://mochitto-cafe.booth.pm/items/5267255",
      },
    ],
    description:
      "今注目を集めているベクトル検索に関する本です。2022/5より全文検索エンジン上でベクトル検索が可能になったSolr9の使い方とともに紹介します。",
    img: solrbook,
    badges: ["Self-Authored", "Solr", "Python", "MachineLearning", "NLP"],
  },
  {
    title: "今日から始めるSolrベクトル検索～Supplemental Book～",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/n3mPcAsU2Bymu1s0x8uj8t",
      },
      {
        name: "BOOTH",
        link: "https://mochitto-cafe.booth.pm/items/5284794",
      },
    ],
    description:
      "「今日から始めるSolrベクトル検索」では書ききれなかった補足内容やその後のアップデート情報をまとめた一冊です。Solrに留まらず、広くベクトル検索とChatGPTを始めとするLLMとの関係性について解説しています。",
    img: solrsupbook,
    badges: ["Self-Authored", "Solr", "VectorSearch", "NLP", "LLM", "ChatGPT"],
  },
  {
    title: "Word2Vec使い倒しブック～Hello Worldから最近の研究成果まで～",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/5410699079581696",
      },
    ],
    description:
      "自然言語処理の定番手法となっているWord2Vecを使い倒すべく、TIPSを詰め込みました。実装例をたくさん載せましたので、結果を見ながら理解できると思います。みなさんのサービス開発、アプリ開発ライフの一助になれば幸いです。",
    img: word2vecbook,
    badges: ["Self-Authored", "Python", "Golang", "Node.js", "NLP"],
  },
  {
    title: "5分で紹介Streamlit",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/p8G4N68KpTdgwCVNFN1Y5H",
      },
    ],
    description:
      "StreamlitというPython用のWebアプリ作成フレームワークの魅力について、短時間で概観できる一冊です。普段、Pythonなどのバックエンドが中心のあなた！Streamlitを知ってしまったからには「自分、HTML書けないんで」はWebアプリを作らない理由にはできません。これを機にあなたもWebアプリを作ってリリースしてみましょう！",
    img: streamlitbook,
    badges: ["Self-Authored", "Python"],
  },
  {
    title: "新しい挑戦をしたい時に見る本 Vol2.5",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/5232700101230592",
      },
      {
        name: "BOOTH",
        link: "https://manntera.BOOTH.pm/items/1940409",
      },
    ],
    description:
      "『新しい挑戦をしたいときに見る本』シリーズとは、まんてらスタジオに集まっているクリエイター達が、好き勝手に自分の書きたい物を提示して、好き勝手に技術書を書き、それを我々で一つの本にして出版しているプロジェクトの事です。私は【09】対話型日記BOT開発を通じて学ぶ自然言語処理入門で参加しています。",
    img: trybook2,
    badges: ["Contribution", "Python"],
  },
  {
    title: "新しい挑戦をしたい時に見る本 Vol3",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/6134416831152128",
      },
      {
        name: "BOOTH",
        link: "https://manntera.BOOTH.pm/items/2015538",
      },
    ],
    description:
      "「君の求めるキッカケがここにある」と⾔うキャッチコピーの元、新しい事をやってみたいけど何に挑戦したら良いか分からない！ と⾔う⼈向けに頒布している本です。クリエイター集団であるまんてらスタジオで、様々な分野のクリエイターにお願いをして本書に寄稿をして頂きました。この本を⼀通り読めば、とりあえず何かしらやりたい事が⾒つかるはずです。私は「React & GAS で動的ホームページ制作」で参加しています。",
    img: trybook3,
    badges: ["Contribution", "React", "Javascript"],
  },
  {
    title: "まんてらスタジオ Google Apps Script Cookbook",
    links: [
      {
        name: "SHOP",
        link: "https://techbookfest.org/product/6194211567173632",
      },
      {
        name: "BOOTH",
        link: "https://manntera.BOOTH.pm/items/2457200",
      },
    ],
    description:
      "Google Apps Scriptについての事例集です。機能がシンプル故に決まった使い方がないので、どうやって使ったらいいのか・いつも同じような使い方になってしまうということがあると思います。 本書では実際の事例や使い方について紹介することで、GAS をさまざまな場面で使える方法について知ることができます。私は「GASでスケジュールクローラーを作ろう」で参加しています。",
    img: gasbook,
    badges: ["Contribution", "Javascript"],
  },
];
const libraries = [
  {
    title: "react-poor-search",
    links: [
      {
        name: "NPM",
        link: "https://www.npmjs.com/package/@sashimimochi/react-poor-search",
      },
      {
        name: "GITHUB",
        link: "https://github.com/Sashimimochi/react-poor-search",
      },
    ],
    description:
      "フロントエンドだけで完結することを目指したReact用の簡易検索コンポーネントです。",
    img: reactPoorSearch,
    badges: ["React", "Excel"],
  },
];

function GalleryCard({ galleryItem }) {
  return (
    <Card sx={{ maxWidth: 700 }}>
      <CardMedia component="img" height="240" image={galleryItem.img} />
      <CardContent>
        <h2 className="card-title">{galleryItem.title}</h2>
        <div className="badges">
          {galleryItem.badges.map((badge, _) => {
            return <div className="badge">{badge}</div>;
          })}
        </div>
        <div className="card-description">{galleryItem.description}</div>
      </CardContent>
      <CardActions>
        {galleryItem.links.map((link, _) => {
          return (
            <a
              className="external-btn"
              href={link.link}
              target="_blank"
              rel="noopener noreferrer"
              key={link.link}
            >
              <BiLinkExternal /> {link.name}
            </a>
          );
        })}
      </CardActions>
    </Card>
  );
}

const Contents = (items) => {
  return (
    <>
      <div className="gallerys">
        {items.map((galleryItem, _) => {
          return (
            <GalleryCard galleryItem={galleryItem} key={galleryItem.title} />
          );
        })}
      </div>
    </>
  );
};

function GalleryCards({ portfolioMode }) {
  if (portfolioMode === "illustrator") {
    return (
      <>
        <div className="title">
          <TypingText text="Gallery" wrapper="h2" />
        </div>
        <div className="subtitle">
          <h3>Illustrations</h3>
        </div>
        <IllustratorGallery />
      </>
    );
  }

  return (
    <>
      <div className="title">
        <TypingText text="Gallery" wrapper="h2" />
      </div>
      <div className="subtitle">
        <h3>Books</h3>
      </div>
      <SlideInLeft component={Contents(books)} />
      <div className="subtitle">
        <h3>Applications</h3>
      </div>
      <SlideInLeft component={Contents(apps)} />
      <div className="subtitle">
        <h3>Libraries</h3>
      </div>
      <SlideInLeft component={Contents(libraries)} />
    </>
  );
}

export default GalleryCards;
